import { Offcanvas, Collapse } from 'bootstrap';
import './slider';
import './fontawesome';
import './forms';
import './masonry';
import './nav';

window.Offcanvas = Offcanvas;
window.Collapse = Collapse;
